<template src="./template.html"></template>
<script>
import Promise from 'bluebird'
import { mapState } from 'vuex'

import affiliateService from 'api/affiliate'
import membershipLib from 'lib/membership'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'
import Login from 'components/Login'

export default {
  name: 'membership',
  components: {
    Login,
  },
  props: {
    modalMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      //
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    isUserMember() {
      return membershipLib.isUserMember(this.user)
    },
  },
  data() {
    return {
      showLogin: false,
      mounted: false,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    onClose() {
      this.$emit('close')
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.LOGOUT_SUCCESS) {
        this.$router.push({
          name: 'MembershipStart',
        })
      } else if (mutation.type === mutationTypes.LOGIN_SUCCESS) {
        this.loading = true

        this.$store.dispatch('getCurrentUser').then(() => {
          this.showLogin = false

          if (this.isUserMember) {
            this.$router.push({
              name: 'MembershipPerks',
            })
          } else {
            this.$router.push({
              name: 'MembershipSelectPlan',
            })
          }
        })
      }
    },
  },
  mounted() {
    this.mounted = true

    this.storeUnsubscribe = store.subscribe(this.onMutation)

    if (this.loggedIn) {
      (!this.user ? this.$store.dispatch('getCurrentUser') : Promise.resolve()).then(() => {
        if (this.isUserMember) {
          this.$router.push({
            name: 'MembershipPerks',
          })
        }
      })
    } else {
      this.$router.push({
        name: 'MembershipStart',
      })
    }

    if (this.affiliateId) {
      this.loading = true

      affiliateService.getById(this.affiliateId).then((result) => {
        this.$store.dispatch('setCurrentMembershipAffiliate', result)

        this.loading = false
      })
    }
  },
  destroyed() {
    this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Membership/index.vue